//-----------------------------------------------------------------------
// <copyright file="navbar.ts" company="LGT India">
//     Author: Sivapriya, Vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { firstValueFrom } from "rxjs";
import { environment } from "../../environments/environment.onprem";
import { AppComponent } from "../app.component";
import { LogoutDialogComponent } from "../logout-dialog/logout-dialog.component";
import { ApiService } from "../services/api.service";
import { AuthService } from "../services/auth.service";
import { WelcomeDialogComponent } from "../welcome-dialog/welcome-dialog.component";
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  email: string = "";
  loginAccessData: string | null = "";
  loginSaData: string = "";
  isAdmin: boolean = true;
  tokenExpirationTimer: any;
  loginTrue: boolean = false;
  isLoading: boolean = false;
  redirectUri: string = "";
  token: string | null = "";
  version : string = environment.envVar.version;
  private redirectionUrl = environment.envVar.redirectionUrl;
 

  constructor(
    public auth: AuthService,
    public dialog: MatDialog,
    private router: Router,
    public app: AppComponent,
    private apiService: ApiService,
    private snackBar: MatSnackBar
  ) {}
  pageEvent = { pageIndex: 0, pageSize: 10, length: 100 };

  async ngOnInit() {
    if (this.app.queryCode) {
      await this.handleCodeLogin();
    }
    this.handleCookies();
  }

  private async handleCodeLogin() {
    this.isLoading = true;

    try {
      const codeVerify:any = sessionStorage.getItem("code_verifier");
      this.redirectUri = `${this.redirectionUrl}/dashboard`;
      const res = await firstValueFrom(
        this.apiService.postCodeLogin(
          this.app.queryCode,
          codeVerify,
          this.redirectUri
        )
      );

      this.isLoading = false;

      this.processLoginResponse(res);
    } catch (err) {
      this.openSnackBar("Application Access Denied.");
    }
  }

  private processLoginResponse(res: any) {
    if (this.app.queryCode && res.status === 200) {
      this.updateCookies(res);

      if (res?.data?.login_access === "Yes") {
        this.loginTrue = true;
        this.router.navigate(["/dashboard"]);
      } else {
        this.router.navigate(["/"]);
        this.openSnackBar("Application Access Denied.");
      }
    } else {
      this.openSnackBar("Application Access Denied.");
    } 
  }

  private updateCookies(res: any) {
   // Set the access token in the session storage
   sessionStorage.setItem("accessToken", res?.data?.accessToken);
   // Set other relevant data in the session storage if needed
   sessionStorage.setItem("userName", res?.data?.account_name);
   sessionStorage.setItem("login_access", res?.data?.login_access);
   sessionStorage.setItem("login_sa", res?.data?.login_sa);
   sessionStorage.setItem("refreshToken", res?.data?.refreshToken);
  }

  private handleCookies() {
    const hasCookie = sessionStorage.getItem("accessToken");
    const loginAccess = sessionStorage.getItem("login_access");
    // const expirationTime: any = this.cookieService.check("accessToken");
    this.token = sessionStorage.getItem("accessToken");
    // this.setLogoutTimer(expirationTime);
    this.loginAccessData = loginAccess;

    const loginSa:any = sessionStorage.getItem("login_sa");
    this.loginSaData = loginSa;

    if (!hasCookie) {
      this.router.navigate([""]);
    } else {
      this.handleLoggedInUser();
    }
  }

  private handleLoggedInUser() {
    const name:any = sessionStorage.getItem("userName");
    this.email = name;
    this.isAdmin = this.checkAdminStatus();

    if (this.loginTrue) {
      this.dialog.open(WelcomeDialogComponent);
    }

    document.querySelector(".nav-bar-top")?.classList.add("open-dialog");
  }

  setLogoutTimer(expirationTime: number) {
    const expiresIn = expirationTime - Date.now(); // Calculate remaining time
    this.tokenExpirationTimer = setTimeout(() => {
      this.app.logout(); // Logout when the token expires
    }, expiresIn);
  }

  clearLogoutTimer() {
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer); // Clear the timer
      this.tokenExpirationTimer = null;
    }
  }
  checkAdminStatus(): boolean {
    return this.loginAccessData === "admin";
  }

  selectedTab: string = "viewTransactions";
  selectedTabIndex: number = 0;

  onSelectTab(index: number): void {
    this.selectedTabIndex = index;
  }
  // Pagination
  getCustomPageRange(): number[] {
    const currentPage = this.pageEvent.pageIndex + 1;
    const totalPages = Math.ceil(
      this.pageEvent.length / this.pageEvent.pageSize
    );
    const pageRange = 3;

    const startPage = Math.max(1, currentPage - pageRange);
    const endPage = Math.min(totalPages, currentPage + pageRange);

    const pages: any = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (startPage > 1) {
      pages.unshift(-1);
    }
    if (endPage < totalPages) {
      pages.push(-1);
    }

    return pages;
  }

  onPageClick(page: number): void {
    if (page !== -1) {
      this.pageEvent = { ...this.pageEvent, pageIndex: page - 1 };
    }
  }

  checkDataImage() {
    if (this.loginAccessData == "Yes" && this.loginSaData == "Yes") {
      return "assets/icons/adminIcon.svg";
    } else {
      return "assets/icons/userIcon.svg";
    }
  }
  checkUser(): string {
    return this.loginAccessData === "Yes" && this.loginSaData === "Yes"
      ? "Admin"
      : "User";
  }

  openLogoutDialog() {
    this.dialog.open(LogoutDialogComponent);
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: 2000, // Optional: Set duration in milliseconds
      horizontalPosition: "center", // Optional: Set horizontal position
      verticalPosition: "top", // Optional: Set vertical position
    });
  }
}
